/*
    Add here your own custom javascript
*/
$(document).ready(function(){
    $('.menu-item-parent').each(function() {
        var href = $(this).attr('href');
        if (href && href.includes('/collections/jewellery-1')) {
            $(this).attr('href', '/collections/jewellery');
        }else if(href && href.includes('/collections/gems-1')){
            $(this).attr('href', '/collections/gems');
        }
    });
});